/**
 * 로그인 뒤 돌아갈 곳.
 *
 * MCP 연결은 AI 도구가 연 브라우저 탭에서 시작해요 — `/connect?request=…` 에 로그인 없이 닿으면
 * 로그인을 거쳐 **그 주소 그대로**(쿼리 포함) 돌아와야 요청이 이어집니다. 쿼리를 잃으면 동의
 * 화면이 "요청을 찾을 수 없어요" 로 끝나고, 사용자는 AI 도구에서 처음부터 다시 해야 해요.
 *
 * 우리 앱 안쪽 경로만 받아요(열린 리디렉터 방지): `/` 로 시작하되 `//`·`/\` 는 다른 호스트로
 * 읽힐 수 있어 거부하고, 로그인·가입 화면으로 되돌아가는 순환도 막아요.
 */
export function returnTo(state: unknown, search = "", fallback = "/dashboard"): string {
  const fromState = (state as { from?: unknown } | null)?.from;
  const fromQuery = new URLSearchParams(search).get("next");
  for (const candidate of [fromState, fromQuery]) {
    if (isSafeInternalPath(candidate)) return candidate;
  }
  return fallback;
}

export function isSafeInternalPath(value: unknown): value is string {
  if (typeof value !== "string" || !value.startsWith("/")) return false;
  if (value.startsWith("//") || value.startsWith("/\\")) return false;
  return !/^\/(login|signup)(?:[/?#]|$)/.test(value);
}

/** 401 로 로그인에 보낼 때 붙이는 `?next=` — 지금 보던 경로(쿼리 포함)를 기억해요. */
export function loginUrlFor(path: string): string {
  return isSafeInternalPath(path) ? `/login?next=${encodeURIComponent(path)}` : "/login";
}
